<template>
    <div class="has-text-white top40 scrollableY " :class="{cmsInAccWidther: !$parent.userAttrs}">
       <!--  <div class="is-size-3 settsPad">CONTACT</div> -->
        <div>
            <div class="container left20">
                <div>
                    <br>
                    <div class="top80 has-text-centered has-text-white">
                        <div class="midTitle "><b>Don't be a stranger</b></div>
                        <div class="top10 is-size-5 has-text-coolGreen"><b>We'd love to hear from you.</b></div>
                        <!-- <div class=" is-size-5">info@miimu.com</div> -->
                        <div v-show="showThanks" class="top20 has-text-bold is-size-5">Thank you! Your message has been sent.</div>
                        

                        <br/>
                        <div class="wideLimitWidth marginAutod ">
                            <div class="field" >
                                <input  type="text" placeholder="Name" class="input azTextInput phWhite" name="Name"  v-model="name" />
                            </div>
                            <div class="field posRelative" >
                                <input  type="text" placeholder="Email" class="input azTextInput" name="Email"  v-model="email" />
                               
                            </div>
                            <div class="field posRelative" >
                                <input  type="text" placeholder="Subject" class="input azTextInput" name="Subject"  v-model="subject" />
                               
                            </div>

                            <div class="field posRelative" >
                                <textarea   placeholder="Message" class="input azTextInput" name="Message"  v-model="message" rows="5" style="height: 150px" ></textarea>
                            </div>

                            <button class="button is-coolGreen top10" @click="sendEmail">SUBMIT</button>
                        </div>


                    </div>
                    <div class="top80">&nbsp;</div>
                </div>
            </div>
        
        </div>
       <!-- <footerDiv></footerDiv> -->
    </div>
</template>

<script>



import footerDiv from './Footer.vue'
export default {
    name: 'settscontact',
    components: {footerDiv},

    data: function(){
        return {
            name: '',
            email: '',
            subject: '',
            message: '',
            showThanks: false
            
        }
    },

    methods: {

    sendEmail: function(){
        var self = this;
        function w(d){
            self.showThanks = true
            self.name = '',
            self.email = '',
            self.subject = '',
            self.message = ''
        }

        function n(){

        }

        if(this.name == '' || this.email == '' || this.subject == '' || this.message == ''){
            this.$root.app.showModalOK({message: 'All fields are required'})
            return
        }

        this.$root.app.apiClient.post('open/confirm/contact', {name: this.name, email: this.email, subject: this.subject, message: this.message}, w, n)
    },

    showLogin: function(){
        this.$root.app.showModalLogin({})
    }


    }
}
</script>